export const MFA_VERIFY_FACTOR_FIRST_TIME = 'app/MFA/MFA_VERIFY_FACTOR_FIRST_TIME';
export const MFA_RESEND_CODE_FIRST_TIME = 'MFA_RESEND_CODE_FIRST_TIME';
export const UPDATE_RESEND_CODE_TIMER = 'app/MFAFactorFirstTime/UPDATE_RESEND_CODE_TIMER';
export const RESET_SUCCESS_STATE ='app/MFAFactorFirstTime/RESET_SUCCESS_STATE';
export const RESEND_COUNTER_TIME = 60;